var __jsx = React.createElement;
import { Tooltip } from '@material-ui/core';
import React, { useEffect, useState } from 'react';
import { useIntl } from 'react-intl';
import { Anchor } from 'theme/icons';
import { AnchorContainer, AnchorDiv, CustomPopper } from './ImageAnchorSelector.style';

var ImageAnchorSelector = function ImageAnchorSelector(_ref) {
  var setImageAnchor = _ref.setImageAnchor,
      imageAnchor = _ref.imageAnchor,
      crop = _ref.crop,
      displayedRatio = _ref.displayedRatio;
  var intl = useIntl();

  var _useState = useState({
    positionX: crop.width / 2,
    positionY: crop.height / 2
  }),
      currentImageAnchor = _useState[0],
      setCurrentImageAnchor = _useState[1];

  var _useState2 = useState({
    positionX: 0,
    positionY: 0
  }),
      startPosition = _useState2[0],
      setStartPosition = _useState2[1];

  useEffect(function () {
    if (imageAnchor !== undefined) {
      setCurrentImageAnchor({
        positionX: imageAnchor.positionX / displayedRatio.ratioX,
        positionY: imageAnchor.positionY / displayedRatio.ratioY
      });
    } else {
      setCurrentImageAnchor({
        positionX: crop.width / 2,
        positionY: crop.height / 2
      });
    }
  }, [imageAnchor, displayedRatio, crop]);

  var handleDragStart = function handleDragStart(event) {
    setStartPosition({
      positionX: event.clientX,
      positionY: event.clientY
    });
  };

  var handleDragEnd = function handleDragEnd(event) {
    var anchorIconSize = 12; // in px, to make sure the icon stays in the area

    var currentPosX = currentImageAnchor.positionX + event.clientX - startPosition.positionX;
    var currentPosY = currentImageAnchor.positionY + event.clientY - startPosition.positionY;
    var posX = currentPosX < 0 ? anchorIconSize : currentPosX > crop.width ? crop.width - anchorIconSize : currentPosX;
    var posY = currentPosY < 0 ? anchorIconSize : currentPosY > crop.height ? crop.height - anchorIconSize : currentPosY;
    setCurrentImageAnchor({
      positionX: posX,
      positionY: posY
    });
    setImageAnchor({
      positionX: posX * displayedRatio.ratioX,
      positionY: posY * displayedRatio.ratioY
    });
  };

  return __jsx(AnchorContainer, {
    onDragOver: function onDragOver(event) {
      return event.preventDefault();
    }
  }, __jsx(Tooltip, {
    title: intl.formatMessage({
      id: "image-cropper-modal.anchorHover"
    }),
    placement: "right",
    classes: {
      tooltip: 'tooltip'
    },
    PopperComponent: CustomPopper
  }, __jsx(AnchorDiv, {
    onDragEnd: handleDragEnd,
    onDragStart: handleDragStart // it is needed to stop the event propagation to prevent
    // ReactCrop event to be activated when moving the anchor
    ,
    onPointerDown: function onPointerDown(event) {
      return event.stopPropagation();
    },
    draggable: true,
    anchor: currentImageAnchor,
    "data-testid": "image-anchor"
  }, __jsx(Anchor, null))));
};

export default ImageAnchorSelector;